import { render, staticRenderFns } from "./HomeLawMasterFollowUp.vue?vue&type=template&id=c1e381ca&scoped=true"
import script from "./HomeLawMasterFollowUp.vue?vue&type=script&lang=js"
export * from "./HomeLawMasterFollowUp.vue?vue&type=script&lang=js"
import style0 from "./HomeLawMasterFollowUp.vue?vue&type=style&index=0&id=c1e381ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e381ca",
  null
  
)

export default component.exports